import type { HookFormSubmitHandler } from 'common/models';
import { FormError, FormWrapper, SubmitButton, TextInput } from 'components/forms/hook-form';
import { useCustomTranslation } from 'helpers/translationHelper';
import { useValidators } from 'helpers/validation';

interface Props {
  onSubmit: HookFormSubmitHandler<TenantCodeFormValues>;
}

export interface TenantCodeFormValues {
  tenantCode: string;
}

const TenantCodeForm = ({ onSubmit }: Props) => {
  const { t } = useCustomTranslation();
  const validators = useValidators();

  const defaultValues: TenantCodeFormValues = {
    tenantCode: ''
  };

  return (
    <FormWrapper defaultValues={defaultValues} onSubmit={onSubmit}>
      <TextInput
        label={t('login.forms.tenantCodeLabel')}
        name="tenantCode"
        required
        options={{
          required: validators.required,
          maxLength: validators.maxLength(49),
          validate: validators.tenantCode
        }}
      />
      <FormError />
      <SubmitButton
        label={t('login.forms.findTenantButton')}
        className="public-btn"
        ignoreDirtyCheck
      />
    </FormWrapper>
  );
};

export default TenantCodeForm;
